import { gql } from '@apollo/client';

export const GET_JOBS_BY_TYPE = gql`
  query GetJobsByType($jobType: JobType!, $portfolioId: ID!, $limit: Int) {
    jobs(jobType: $jobType, portfolioId: $portfolioId, limit: $limit) {
      id
      portfolioId
      type
      status
      stage
      result
      error
      attempts
      createdAt
      updatedAt
      retryAt
      ... on TxImportJob {
        sourceName
        rowCount
        assetKind
        importSource
      }
    }
  }
`;

export const GET_ALL_JOBS = gql`
  query GetAllJobs($portfolioId: ID!, $limit: Int) {
    jobs(portfolioId: $portfolioId, limit: $limit) {
      id
      portfolioId
      type
      status
      stage
      result
      error
      attempts
      createdAt
      updatedAt
      retryAt
      ... on TxImportJob {
        sourceName
        rowCount
        assetKind
        importSource
      }
      ... on TxExportJob {
        rowCount
        fileSize
        fileName
      }
    }
  }
`;

